import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../../api/categories/getCategories';
import { useState } from 'react';

export const useGetCategories = (params?: Record<string, string | number>) => {
  const [page, setPage] = useState(1);

  const { data, isSuccess, isLoading, refetch } = useQuery({
    queryKey: ['getCategories', page],
    queryFn: () => getCategories({ page, ...params }),
  });

  return {
    categoriesData: data,
    isGetCategoriesSuccess: isSuccess,
    isGetCategoriesLoading: isLoading,
    categoriesRefetch: refetch,
    setPage,
    page,
  };
};
